import { lazy } from 'react';

/**
 * React.lazy whose code can be requested before the component first renders, by calling
 * `Component.preload()`. The render then reuses that download. A failed preload is
 * forgotten, so the render asks for the chunk again (and fails the usual way if it must).
 */
const lazyWithPreload = (load) => {
  let pending = null;
  const loadOnce = () => {
    if (!pending) {
      pending = load().catch((error) => {
        pending = null;
        throw error;
      });
    }
    return pending;
  };

  const Component = lazy(loadOnce);
  Component.preload = () => {
    loadOnce().catch(() => {});
  };
  return Component;
};

export default lazyWithPreload;
